<template>
  <div class="home-wrap">
    <div class="padding-15 padding-b-30">
      <div class="part-wrap padding-12-15">
        <div>
          <span class="part-title">套餐类型</span>
          <span class="part-content">{{basicInfo.name}}</span>
        </div>
        <div>
          <span class="part-title">有效期</span>
          <span class="part-content">{{basicInfo.effectTime}} {{getTimeTip()}}</span>
        </div>
      </div>
      <div class="balance-wrap">
        <div>
          <div class="balance-content">{{basicInfo.settleBalance?basicInfo.settleBalance:0}}</div>
          <div class="balance-title">剩余可提现(元)</div>
        </div>
        <div class="withdraw-box">
          <span class="withdraw-btn" @click="withdraw()">提现</span>
        </div>
      </div>
      <div class="data-wrap">
        <div class="data-card">
          <div class="card-head">
            <div><span class="font-11">本月新增会员数</span></div>
            <div><span class="font-11">{{statisticsInfo.userCountMonth}}</span></div>
          </div>
          <div class="card-content">
            <div class="card-num"><span class="value">{{statisticsInfo.userCountToday}}</span><span class="font-11">个</span></div>
            <div class="content-desc"><span class="font-11">今日新增会员</span></div>
            <div class="content-info" :class="{'up-color':increaseUser >0}">
              <span class="font-11">{{increaseUser>0?'较昨日上升':'较昨日下降'}}<span>{{Math.abs(increaseUser)}}</span>个</span>
              <img src="../../../../assets/img/h5/official/icon_arrow_rising.png" v-if="increaseUser>0" />
              <img src="../../../../assets/img/h5/official/icon_arrow_falling.png" v-else />
            </div>
          </div>
        </div>
        <div class="data-card">
          <div class="card-head">
            <div><span class="font-11">本月新增订单数</span></div>
            <div><span class="font-11">{{statisticsInfo.orderCountMonth}}</span></div>
          </div>
          <div class="card-content">
            <div class="card-num"><span class="value">{{statisticsInfo.orderCountToday}}</span><span class="font-11">件</span></div>
            <div class="content-desc"><span class="font-11">今日新增订单</span></div>
            <div class="content-info" :class="{'up-color':increaseOrder >0}">
              <span class="font-11">{{increaseOrder>0?'较昨日上升':'较昨日下降'}}<span>{{Math.abs(increaseOrder)}}</span></span>
              <img src="../../../../assets/img/h5/official/icon_arrow_rising.png" v-if="increaseOrder>0" />
              <img src="../../../../assets/img/h5/official/icon_arrow_falling.png" v-else />
            </div>
          </div>
        </div>
        <div class="data-card">
          <div class="card-head">
            <div><span class="font-11">本月结算收入</span></div>
            <div><span class="font-11">{{statisticsInfo.commissionMonth}}</span></div>
          </div>
          <div class="card-content">
            <div class="card-num"><span class="value">{{statisticsInfo.commissionToday}}</span><span class="font-11">元</span></div>
            <div class="content-desc"><span class="font-11">今日佣金</span></div>
            <div class="content-info" :class="{'up-color':increaseCommission >0}">
              <span class="font-11">{{increaseCommission>0?'较昨日上升':'较昨日下降'}}<span>{{Math.abs(increaseCommission).toFixed(2)}}</span></span>
              <img src="../../../../assets/img/h5/official/icon_arrow_rising.png" v-if="increaseCommission>0" />
              <img src="../../../../assets/img/h5/official/icon_arrow_falling.png" v-else />
            </div>
          </div>
        </div>
        <div class="data-card">
          <div class="card-head">
            <div><span class="font-11">本月推广利润</span></div>
            <div><span class="font-11">{{statisticsInfo.profitMonth}}</span></div>
          </div>
          <div class="card-content">
            <div class="card-num"><span class="value">{{statisticsInfo.profitToday}}</span><span class="font-11">元</span></div>
            <div class="content-desc"><span class="font-11">今日利润</span></div>
            <div class="content-info" :class="{'up-color':increaseProfit >0}">
              <span class="font-11">{{increaseProfit>0?'较昨日上升':'较昨日下降'}}<span>{{Math.abs(increaseProfit).toFixed(2)}}</span></span>
              <img src="../../../../assets/img/h5/official/icon_arrow_rising.png" v-if="increaseProfit>0" />
              <img src="../../../../assets/img/h5/official/icon_arrow_falling.png" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-11-15 padding-b-22">
      <div class="title-text">近30日数据趋势</div>
      <div class="echart-content">
        <div class="echart-dom" id="chart-line-box"></div>
      </div>
    </div>
    <Withdraw ref="withdraw"></Withdraw>
    <Realname ref="realname"></Realname>
  </div>
</template>

<script>
import Withdraw from '@/views/h5/official/statistics/modal/Withdraw.vue'
import Realname from '@/views/h5/official/statistics/modal/Realname.vue'
import { getUserUUID, getNickname, getPlatformUuid, getIsBasic, getIsAuthOfficial, setPlatformUuid, setPlatformName, setIsBasic, setHasPackage, setIsAuthOfficial, getSnaphotId, setSnapshotId, setIsOver, setHeadImg } from '@/utils/auth'
import echarts from 'echarts'
import home from '@/javaApi/home'
const homeModel = new home()
import official from '@/javaApi/official'
const officialModel = new official()
export default {
  name: "Wechat",
  components: {
    Withdraw,
    Realname
  },
  data: function () {
    return {
      platformUuid: getPlatformUuid(),
      snapshotId: getSnaphotId() || 0,
      chartLine: undefined,
      listLoading: false,
      //isRealName: false,
      activeIndex: 0,
      basicInfo: {
        settleBalance: '0.00',
        effectTime: '',
        name: ''
      },
      statisticsInfo: {
        commissionMonth: '0.00',
        commissionToday: '0.00',
        commissionYesterday: '0.00',
        orderCountMonth: '0',
        orderCountToday: '0',
        orderCountYesterday: '0',
        profitMonth: '0.00',
        profitToday: '0.00',
        profitYesterday: '0.00',
        userCountMonth: '0',
        userCountToday: '0',
        userCountYesterday: '0'
      },
      report: {
        dayList: [],
        orderNumList: [],
      },
      isBasic: getIsBasic() === 'true' ? true : false,
      isAuth: getIsAuthOfficial() === 'true' ? true : false,
      userUUID : getUserUUID(),
    }
  },
  computed:{
    increaseUser:function () {
      let increaseUser = this.statisticsInfo.userCountToday - this.statisticsInfo.userCountYesterday
      return parseInt(increaseUser)
    },
    increaseOrder:function () {
      let increaseOrder = this.statisticsInfo.orderCountToday - this.statisticsInfo.orderCountYesterday
      return parseInt(increaseOrder)
    },
    increaseCommission:function () {
      let commission = this.statisticsInfo.commissionToday - this.statisticsInfo.commissionYesterday
      return parseFloat(commission)?parseFloat(commission):0
    },
    increaseProfit:function () {
      let profit = this.statisticsInfo.profitToday - this.statisticsInfo.profitYesterday
      return parseFloat(profit)?parseFloat(profit):0
    }
  },
  mounted: function () {
    this.listLoading = true
    if(parseInt(this.snapshotId) > 0){
      this.initData();
      this.getPubilcInfo();
    }else{
      this.getPubilcInfo();
    }
  },
  methods: {
    initData() {
      let that = this;
      let param = {
      }
      if(that.platformUuid != '' && that.platformUuid!=0){
        param.platformUuid = that.platformUuid
      }
      that.snapshotId = getSnaphotId() || 0
      if(parseInt(this.snapshotId) > 0){
          param.snapshotId = that.snapshotId
      }

      homeModel.getStatisticsData(param).then((response) => {
        console.log(response);
        var res = response.data
        if(res.code != 200){
          let messgae = res.message?res.message:'系统异常请稍后再试'
          that.$Message.error(messgae)
          return
        }
        let condition = (res.data)? (JSON.stringify(res.data) == "{}"):true
        if(!condition){
          if(JSON.stringify(res.data.platformStat)!='{}'){
            that.statisticsInfo = res.data.platformStat;
          }
          that.report = res.data.stringListMap;
          if(JSON.stringify(res.data.snapshotMap)!='{}'){
            that.basicInfo = res.data.snapshotMap;
            // that.basicInfo.settleBalance = 0
          }else{
            //未开通套餐时，点击任何菜单都是跳转到激活续费页面
            // 弹窗提示 尚未购买任何套餐
            that.$router.push('/pc/official/dialog').catch(err => { err })
            if(this.isBasic === true){
              that.$store.dispatch('nav/changeOfficialAccountActiveIndex',5)
            }else{
              that.$store.dispatch('nav/changeOfficialAccountActiveIndex',8)
            }
          }
          that.initEchart();
        }
      }).catch(error=>{
        console.log(error)
        if(error != 'token invalid'){
          this.$Message.error('系统异常请稍后再试！')
        }

      })
      that.listLoading = false
    },
    initEchart: function() {
      if(!this.report){
        this.report.dayList = []
        this.report.orderNumList = []
      }
      if(!this.report.dayList){
        this.report.dayList = []
      }
      if(!this.report.orderNumList){
        this.report.orderNumList = []
      }

      if (this.report.dayList.length == 0) {
        this.report.dayList = ['暂无数据']
      }

      if (this.report.orderNumList.length == 0) {
        this.report.orderNumList = [0];
      }
      let chartLineBox = document.getElementById('chart-line-box')
      if(!chartLineBox){
        return
      }
      this.chartLine = echarts.init(document.getElementById('chart-line-box'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {              //设置tip提示
          trigger: 'axis'
        },
        legend: {               //设置区分（哪条线属于什么）
          data: ['预估订单量']
        },
        color: ['#FF8622'],     //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {                //设置x轴
          type: 'category',
          boundaryGap: false,   //坐标轴两边不留白
          data: this.report.dayList,
          //data: ['2020-12-16', '2020-12-17', '2020-12-18', '2020-12-19', '2020-12-20', '2020-12-21', '2020-12-22', '2020-12-23', '2020-12-24', '2020-12-25', '2020-12-26', '2020-12-27', '2020-12-28', '2020-12-29', '2020-12-30', '2020-12-31'],
          name: '',             //X轴 name
          nameTextStyle: {      //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {           //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53',
            }
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53',
            }
          },
          type: 'value'
        },
        series: [
          {
            name: '订单量',
            //data: [220, 232, 201, 234, 290, 230, 220, 100, 180, 150, 200, 280, 300, 290, 280],
            data: this.report.orderNumList,
            type: 'line',               // 类型为折线图
            lineStyle: {                // 线条样式 => 必须使用normal属性
              normal: {
                color: '#3D9EFC',
              }
            },
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    getPubilcInfo(){
      officialModel.publicLogin({openUserUuid:this.userUUID}).then((response) => {
        var res = response.data
        if(res.code != 200){
          setPlatformUuid(0);
          setPlatformName('')
          setSnapshotId(0)
          setIsOver(1)
          setIsBasic(true)
          setHasPackage(false)
          setIsAuthOfficial(false)
          setHeadImg('')
          this.$Message.error(res.message)
          return
        }
        if(res.data.binds.length > 0){
          var defaultOfficial = res.data.binds[0];
          // 获取当前用户选择的公众号
          let tempSnapshotId = this.snapshotId
          if(tempSnapshotId){
            let targetSnapshotId = tempSnapshotId
            if(targetSnapshotId == -1){
              // targetSnapShotId = -1 表示刚刚添加的公众号 买了套餐
              let lastOfficial = res.data.binds.length
              defaultOfficial =  res.data.binds[lastOfficial-1];
            }else{
              let i;
              let tempData;
              for(i=0;i<res.data.binds.length;i++){
                tempData = res.data.binds[i]
                if(targetSnapshotId!=0){
                  if(tempData['snapshotId'] == targetSnapshotId){
                    defaultOfficial = tempData
                    break;
                  }
                }else{
                  if(tempData['id']>0){
                    defaultOfficial = tempData
                    break;
                  }
                }
              }
            }

          }
          setPlatformUuid(defaultOfficial.platformUuid);
          setPlatformName(defaultOfficial.platformName)
          this.basicInfo.name = defaultOfficial.packageName?defaultOfficial.packageName:''
          if(defaultOfficial){
            // this.basicInfo.effectTime = this.$moment(new Date(defaultOfficial.effectTime)).format('YYYY-MM-DD hh:mm:ss')
            let effectTime = defaultOfficial.effectTime;
            if(effectTime){
              let date = new Date(effectTime);
              let year = date.getFullYear();
              let month = date.getMonth() + 1;
              let day = date.getDate();
              let hours = date.getHours()
              let min = date.getMinutes()
              let second = date.getSeconds()
              if (month < 10) {
                month = "0" + month;
              }
              if (day < 10) {
                day = "0" + day;
              }
              if (hours < 10) {
                hours = "0" + hours;
              }
              if (min < 10) {
                min = "0" + min;
              }
              if (second < 10) {
                second = "0" + second;
              }
              this.basicInfo.effectTime = year+'-'+month+'-'+day+' '+hours+':'+min+':'+second
            }
          }
          if(defaultOfficial.snapshotId !== null){
            setSnapshotId(defaultOfficial.snapshotId)
          }else{
            setSnapshotId(0)
          }
          setIsOver(defaultOfficial.isOver)
          setHeadImg(defaultOfficial.headImg)
          if(defaultOfficial.isProfit === 1){
            setIsBasic(false)
          }else{
            setIsBasic(true)
          }
          if(defaultOfficial.packageName !== null){
            setHasPackage(true)
          }else{
            setHasPackage(false)
          }
          if(defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== ''){
            setIsAuthOfficial(true)
            this.isAuth = true
          }else{
            setIsAuthOfficial(false)
            this.isAuth = false
          }
        }
        this.snapshotId = getSnaphotId() || 0
        if(parseInt(this.snapshotId) > 0){
          this.initData()
        }
        this.listLoading = false
      }).catch(error=>{
        this.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统异常请稍后再试！')
        }
      })
    },
    //提现
    withdraw: function () {
      // if(this.isRealName){//已实名
        let settleBalance = 0
        if(this.basicInfo){
          settleBalance  = parseFloat(this.basicInfo.settleBalance)
        }
        settleBalance = settleBalance?settleBalance:0
        if(settleBalance<=0){
          this.$Message.error('暂无可提现金额')
          return
        }
        this.$refs.withdraw.init(settleBalance)
      // }else{//未实名认证
      //   this.$refs.realname.init()
      // }
    },
    //授权
    auth: function () {
      if(this.isBasic === true){
        this.$store.dispatch('nav/changeOfficialAccountActiveIndex',4)
      }else{
        this.$store.dispatch('nav/changeOfficialAccountActiveIndex',7)
      }
      this.$router.push({
        path: '/pc/official/authorization',
      });
    },
    getRequest() {
      var url = location.search; //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for(var i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    // 是否过期的判断
    getTimeTip(){
      let now = this.$moment()
      let effectTime = this.$moment(this.basicInfo.effectTime)
      let timeDiff = effectTime.diff(now)
      if(timeDiff>0){
        return ''
      }
      return '(已过期)'
    }
  }
}
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .part-wrap{
      background: rgba(#EAEAF8,0.85);
      display: flex;
      justify-content: space-between;
      color: #7477D5;
      border-radius: 4px 4px 0 0;
      white-space: nowrap;
      .part-title{
        opacity: 0.6;
        font-size: 12px;
      }
      .part-content{
        margin-left: 5px;
        font-size: 14px;
      }
    }
    .balance-wrap{
      display: flex;
      justify-content: space-between;
      background: #7477D5;
      color: #FFFFFF;
      padding: 23px 15px;
      align-items: center;
      border-radius: 0 0 4px 4px;
      .balance-content{
        font-family: Alibaba-PuHuiTi-M;
        font-size: 18px;
      }
      .balance-title{
        opacity: 0.6;
        font-size: 12px;
      }
      .withdraw-box{
        background: #FFFFFF;
        border-radius: 16px;
        width: 80px;
        height: 32px;
        padding: 7px 26px;
        font-family: Alibaba-PuHuiTi-M;
        font-size: 14px;
        color: #7477D5;
        text-align: center;
      }
    }
    .data-wrap{
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .data-card{
        background: #FFFFFF;
        box-shadow: 0 0 4px 0 rgba(0,0,0,0.08);
        border-radius: 4px;
        width: 49.333333%;
        margin-top: 10px;
        .card-head{
          background: #EEF9FF;
          border-radius: 2px 2px 0 0;
          padding: 7px 10px;
          color: #666666;
          display: flex;
          justify-content: space-between;
        }
        .card-content{
          padding: 10px;
          .card-num{
            line-height: 15px;
            margin-bottom: 5px;
            .value{
              font-size: 18px;
              line-height: 25px;
              font-family: Alibaba-PuHuiTi-M;
              margin-right: 2px;
            }
          }
          .content-desc{
            color: #666666;
          }
          .content-info{
            color: #FF4F76;
            img{
              width: 22px;
            }
          }
          .up-color{
            color: #45D16F;
          }
        }
      }
      .data-card:nth-child(2) .card-head{
        background: #FFF5ED;
      }
      .data-card:nth-child(3) .card-head{
        background: #EBFBF9;
      }
      .data-card:nth-child(4) .card-head{
        background: #F5F3FE;
      }
    }
    .echart-content {
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      width: 100%;
      .echart-dom {
        height: 242px;
        margin: 0 auto;
        padding: 15px 8px;
      }
      .echar-desc {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 8px;
        .detail-item {
          margin-right: 12px;
          .detail-badge {
            border-radius: 100%;
            -webkit-box-shadow: 0 0 0 1px #fff;
            box-shadow: 0 0 0 1px #fff;
            width: 8px;
            height: 8px;
            display: inline-block;
            position: relative;
            top: -1px;
            margin-right: 10px;
          }
          .detail-title {
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            padding-right: 10px;
          }
          .detail-content {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
          }
        }
      }
      .echart-info {
        padding: 8px;
        color: #999999;
        .font-15{
          font-size: 15px;
        }
      }
      .bg-orange {
        background: #ff8622;
      }
      .bg-blue {
        background: #3d9efc;
      }
      .bg-pink {
        background: #ff4f76;
      }
    }
    .table-wrapper {
      width: 100%;
      margin-top: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/official/statistics/Index.vue